export default "__VITE_ASSET__52cb01f6__"